import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MainLayoutDetail from "../../components/layout/MainLayoutDetail";
import SectionBox from "../../components/layout/SectionBox";
import Button from "../../components/atoms/Button";
import StepProgress from "../../components/molecules/StepProgress";
import { TagSelectInput } from "../../components/molecules/TagSelectInput";
import { useJobFilterStore } from "../../store/useJobFilterStore";
import PhoneInput from "react-phone-number-input";

export default function PersonalInformationUser() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const emailFromParams = searchParams.get("email") || "";
    const { locations, skillSet, fetchFilters } = useJobFilterStore();
    const skillOptions = skillSet?.map((item) => ({
        id: item.id,
        name: item.name
    })) ?? [];

    const MAX_SKILLS = 3;

    const handleSelectPopular = (skill: string) => {
        if (skills.includes(skill)) return; // sudah ada, jangan duplikat
        if (skills.length >= MAX_SKILLS) return; // sudah 3, stop

        setSkills([...skills, skill]);
    };

    const [fullName, setFullName] = useState("");
    const [about, setAbout] = useState("");
    const [country, setCountry] = useState("");
    const [date, setDate] = useState("");
    const [city, setCity] = useState("");
    const [skills, setSkills] = useState<string[]>([]);
    const [email, setEmail] = useState(emailFromParams);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [photo, setPhoto] = useState<string | null>(null);

    const handleUploadPhoto = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => setPhoto(reader.result as string);
            reader.readAsDataURL(file);
        }
    };

    const handleNext = () => {
        const currentLang = location.pathname.startsWith("/id") ? "id" : "en";
        navigate(
            `/${currentLang}/user/user-profile`
        );
    };

    const currentLang = location.pathname.startsWith("/id") ? "id" : "en";

    const stepsEN = [
        { number: 1, title: "Confirmation" },
        { number: 2, title: "Personal Information" }
    ];

    const stepsID = [
        { number: 1, title: "Konfirmasi" },
        { number: 2, title: "Informasi Pribadi" }
    ];

    const steps = currentLang === "id" ? stepsID : stepsEN;

    useEffect(() => {
        fetchFilters(currentLang, "all");
    }, []);

    return (
        <MainLayoutDetail>
            <div className="container-section mx-auto mt-32 px-6">
                <SectionBox background="radial-gradient(circle at 50% -100%, rgba(255,255,255,0) 0%, #123b7c 70%)">
                    <div className="mb-10 flex justify-center">
                        <StepProgress steps={steps} currentStep={2} />
                    </div>
                    <div className="bg-white p-4 rounded-2xl shadow-md max-w-4xl mx-auto mt-6">
                        <h2 className="text-center text-2xl font-semibold text-gray-800 mb-8">
                            Personal Information
                        </h2>

                        <div className="flex justify-center mb-6">
                            <label className="relative cursor-pointer group">
                                <div className="w-32 h-32 rounded-full border shadow overflow-hidden bg-white">
                                    <img
                                        src={photo || "https://placehold.co/400x400"}
                                        alt="User Avatar"
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center text-white text-sm rounded-full transition">
                                    Change Photo
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={handleUploadPhoto}
                                />
                            </label>
                        </div>

                        <div className="grid md:grid-cols-1 gap-5 mb-5">
                            <div className="flex flex-col">
                                <label className="text-sm font-medium">{currentLang === "id" ? "Nama Lengkap" : "Full Name"}</label>
                                <input
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                    placeholder="Full Name"
                                    className="border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                                />
                            </div>
                            <div className="flex flex-col">
                                <label className="text-sm font-medium">{currentLang === "id" ? "Nomor Telepon" : "Phone Number"}</label>
                                <PhoneInput
                                    defaultCountry="ID"
                                    international
                                    withCountryCallingCode
                                    value={phoneNumber}
                                    onChange={(value) => setPhoneNumber(value ?? "")}
                                    className="w-full border rounded-lg pl-3 pr-1 py-1 flex flex-col md:flex-row gap-4"
                                />
                            </div>

                        </div>

                        <div className="grid md:grid-cols-2 gap-2">
                            <div className="flex flex-col">
                                <label className="text-sm font-medium">{currentLang === "id" ? "Jenis Kelamin" : "Gender"}</label>

                                <select
                                    value={country}
                                    onChange={(e) => setCountry(e.target.value)}
                                    className="form-input"
                                >
                                    <option value="">Gender</option>
                                    {locations
                                        .filter((loc: any) => loc.country) // pastikan bukan null
                                        .map((loc: any) => (
                                            <option key={loc.id} value={loc.country}>
                                                {loc.country}
                                            </option>
                                        ))}
                                </select>


                            </div>

                            <div className="flex flex-col">
                                <label className="text-sm font-medium">{currentLang === "id" ? "Tanggal Lahir" : "Birth Date"}</label>

                                <input
                                    type="date"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    className="border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                                />
                            </div>

                            <div className="flex flex-col">
                                <label className="text-sm font-medium">{currentLang === "id" ? "Negara" : "Country"}</label>
                                <select
                                    value={country}
                                    onChange={(e) => setCountry(e.target.value)}
                                    className="form-input"
                                >
                                    <option value="">Country</option>
                                    {locations
                                        .filter((loc: any) => loc.country) // pastikan bukan null
                                        .map((loc: any) => (
                                            <option key={loc.id} value={loc.country}>
                                                {loc.country}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="text-sm font-medium">{currentLang === "id" ? "Kota" : "City"}</label>
                                <select
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    className="form-input"
                                >
                                    <option value="">City</option>
                                    {locations.map((loc: any) => (
                                        <option key={loc.id} value={loc.id}>
                                            {loc.city} - {loc.state}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="text-sm font-medium">{currentLang === "id" ? "Status Pernikahan" : "Marital Status"}</label>
                                <select
                                    value={country}
                                    onChange={(e) => setCountry(e.target.value)}
                                    className="form-input"
                                >
                                    <option value="">Marital Status</option>
                                    {locations
                                        .filter((loc: any) => loc.country) // pastikan bukan null
                                        .map((loc: any) => (
                                            <option key={loc.id} value={loc.country}>
                                                {loc.country}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="text-sm font-medium">{currentLang === "id" ? "Ketersediaan Bergabung" : "Join Availability"}</label>
                                <select
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    className="form-input"
                                >
                                    <option value="">Join Availability</option>
                                    {locations.map((loc: any) => (
                                        <option key={loc.id} value={loc.id}>
                                            {loc.city} - {loc.state}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>


                        <div className="flex flex-col">
                            <label className="text-sm font-medium">{currentLang === "id" ? "Tentang Saya" : "About Me"}</label>
                            <textarea
                                value={about}
                                onChange={(e) => setAbout(e.target.value)}
                                placeholder="About Me"
                                rows={4}
                                className="form-input md:col-span-2"
                            />
                        </div>

                        <div className="my-4">
                            <hr />
                            <hr />
                            <hr />
                        </div>

                        <h2 className="text-xl">{currentLang === "id" ? "Apa preferensi pekerjaan Anda?" : "What's your job preference?"}</h2>
                        <p>{currentLang === "id" ? "Ini membantu kami menghubungkan Anda dengan pekerjaan terbaik." : "This helps us connect you to the best jobs"}</p>

                        <div className="mt-6">
                            <TagSelectInput
                                value={skills}
                                onChange={setSkills}
                                options={skillOptions}
                            />
                        </div>

                        <h3 className="mt-6 text-xl font-semibold text-gray-800">Popular Jobs</h3>
                        <div className="flex flex-wrap gap-2 mt-3">
                            {skillOptions.slice(0, 10).map((item) => {
                                const isSelected = skills.includes(item.id);
                                const isDisabled = skills.length >= 3 && !isSelected;

                                return (
                                    <button
                                        key={item.id}
                                        onClick={() => {
                                            if (!isDisabled && !isSelected) setSkills([...skills, item.id]);
                                        }}
                                        disabled={isDisabled}
                                        className={`px-4 py-2 text-sm border rounded-full transition
                                        ${isSelected
                                                ? "bg-primary text-white border-primary"
                                                : "border-gray-300 hover:bg-gray-100"
                                            }
                                        ${isDisabled ? "opacity-40 cursor-not-allowed" : ""}
                                        `}
                                    >
                                        {item.name}
                                    </button>
                                );
                            })}
                        </div>


                        <div className="flex justify-between mt-10">
                            <Button onClick={() => navigate(-1)} className="px-10 !bg-gray-400 hover:bg-gray-500">
                                Back
                            </Button>
                            <Button onClick={handleNext} className="px-10 bg-primary hover:bg-secondary">
                                Finish
                            </Button>
                        </div>
                    </div>
                </SectionBox>
            </div>
        </MainLayoutDetail>
    );
}
